/** Pure up/down list navigation for the `/assets` entry list — clamped (no wraparound past either end). */

export type NavDirection = "up" | "down";

export function nextIndex(current: number, direction: NavDirection, length: number): number {
  if (length <= 0) return -1;
  const delta = direction === "down" ? 1 : -1;
  const proposed = current + delta;
  return Math.min(Math.max(proposed, 0), length - 1);
}
